import { Modal } from 'react-bootstrap';

const ContactDetailsModal = ({ show, onHide, contact }) => {
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title className='display-1'>Contact Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex align-items-center border-bottom mb-3 pb-3">
                    <div className="c-avatar c-avatar-text me-3">
                        J
                    </div>
                    <div>
                        <div className="p-tag fw-bold">John Doe</div>
                        <div className="p-tag">john.doe@example.com</div>
                        <div className="p-tag">+1 234 567 890</div>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <div className="c-avatar c-avatar-text me-3">
                        J
                    </div>
                    <div>
                        <div className="p-tag fw-bold">John Doe</div>
                        <div className="p-tag">john.doe@example.com</div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ContactDetailsModal;
